import _slicedToArray from "/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { useCallback, useMemo } from "react";
import useQueryParams from "./useQueryParams";
var useQueryParam = function useQueryParam(name, paramConfig, options) {
  var paramConfigMap = useMemo(function () {
    return _defineProperty({}, name, paramConfig != null ? paramConfig : "inherit");
  }, [name, paramConfig]);
  var _useQueryParams = useQueryParams(paramConfigMap, options),
    _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
    query = _useQueryParams2[0],
    setQuery = _useQueryParams2[1];
  var decodedValue = query[name];
  var setValue = useCallback(function (newValue, updateType) {
    if (typeof newValue === "function") {
      return setQuery(function (latestValues) {
        var newValueFromLatest = newValue(latestValues[name]);
        return _defineProperty({}, name, newValueFromLatest);
      }, updateType);
    }
    return setQuery(_defineProperty({}, name, newValue), updateType);
  }, [name, setQuery]);
  return [decodedValue, setValue];
};
export { useQueryParam };